import { Link } from 'react-router-dom'
import {
  CHECKOUT_OUTCOME,
  CHECKOUT_OUTCOME_COPY,
  CHECKOUT_UI,
  ORDER_PATHS,
  type CheckoutSuccessProps,
} from '../constants/orders'
import { checkoutPaymentOutcome } from '../helpers/checkout-payment'
import { cx, formatCurrency } from '../helpers/format'
import { checkoutPlacedTotal, paymentStatusLabel } from '../helpers/orders'
import { Icon } from './Icon'
import '../styles/checkout-page.scss'

export function CheckoutSuccess({ orders, split }: CheckoutSuccessProps) {
  const primary = orders[0]
  if (!primary) return null

  const outcome = checkoutPaymentOutcome(orders)
  const copy = CHECKOUT_OUTCOME_COPY[outcome]
  const showSplit =
    split && (outcome === CHECKOUT_OUTCOME.paid || outcome === CHECKOUT_OUTCOME.cod)

  return (
    <section className={cx('checkout-success', `checkout-success--${outcome}`)} role="status">
      <div className="checkout-success__mark" aria-hidden>
        <Icon name={copy.mark} size={30} strokeWidth={2.6} />
      </div>
      <p className="checkout-success__eyebrow">{copy.eyebrow}</p>
      <h2>{copy.title}</h2>
      <p className="checkout-success__lead">{copy.lead}</p>
      {showSplit ? <p className="checkout-success__lead">{CHECKOUT_UI.successSplitLead}</p> : null}
      <ul className="checkout-success__orders">
        {orders.map((order) => (
          <li key={order.id}>
            <span>
              {CHECKOUT_UI.successOrderLabel} {order.orderNumber}
              <small>
                {CHECKOUT_UI.paymentLabel}: {paymentStatusLabel(order.paymentStatus)}
              </small>
            </span>
            <strong>{formatCurrency(order.total)}</strong>
          </li>
        ))}
      </ul>
      <p className="checkout-success__total">
        <span>{CHECKOUT_UI.totalLabel}</span>
        <strong>{formatCurrency(checkoutPlacedTotal(orders))}</strong>
      </p>
      <div className="checkout-success__actions">
        <Link to={ORDER_PATHS.detail(primary.id)} className="checkout-page__continue">
          {CHECKOUT_UI.viewOrder}
        </Link>
        <Link to="/" className="checkout-success__ghost">
          {CHECKOUT_UI.continueShopping}
        </Link>
      </div>
    </section>
  )
}
